var _path, _polygon, _path2, _path3, _polygon2, _g, _rect, _rect2, _rect3, _ellipse, _ellipse2, _rect4, _path4, _path5, _g2, _g3, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1372.99 284.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208,141.5l52,20.91V283.13H208Zm11.41,42.42,29.94,10.34v-9.51l-29.94-11.17Zm0,17,29.94,9.74v-9.27l-29.94-10.21Zm0,17.23,29.94,9.38V218l-29.94-9.27Z",
    fill: "#fff",
    opacity: 0.75
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "207.98 141.5 260.02 162.41 260.02 175.01 207.98 155.05 207.98 141.5",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.42,162.65l69.86-22.33V283.13H132.42Zm11.88,26.14L155,186.65V173.58l-10.69,3.09Zm18.3-4.87,10-2.73v-12.6l-10,2.85Zm17.64-3.83,9.71-1.87V164.85l-9.71,2.41Zm-35,28.66,9.77-2V194.26l-9.77,2.58ZM162.6,205l10-2.76V190l-10,2.94Zm18-4.13,9.35-2V186.33l-9.35,2Zm.44,20.52,8.91-2.05V207.8L181,209.32Zm-17.82,3.48,9.36-1.69V211.1L163.22,213Zm-18,3.39,9.77-2.23-.32-11.45-9.45,1.74Zm21.65,44.1v-34l-14.79,1.69V272.4Zm3.21-.53h14V236.23l-14,2.14Z",
    fill: "#fff",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.43,283.13H103.67s13.3-13.07,95.88-13.31C199.55,269.82,267.39,268.16,295.43,283.13Z",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.51 156.83 205.01 134.55 257.59 156.83 257.59 144.71 204.3 120.3 135.51 144.71 135.51 156.83",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.48,
    cy: 276.99,
    r: 7.59,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.48,
    cy: 276.99,
    r: 7.59,
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.18,
    y: 144.59,
    width: 5.82,
    height: 32.32,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.18,
    y: 144.59,
    width: 5.82,
    height: 32.32,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.92,
    y: 125.85,
    width: 8.34,
    height: 32.32,
    transform: "translate(-73.92 210.1) rotate(-90)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.79,
    cy: 144.35,
    rx: 6.6,
    ry: 5.42,
    transform: "translate(-101.46 150.19) rotate(-72.45)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.65,
    cy: 144.35,
    rx: 5.42,
    ry: 6.6,
    transform: "translate(-39.59 32.25) rotate(-17.55)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.41,
    y: 170.2,
    width: 89.82,
    height: 101.58,
    rx: 11.76,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.94,105.74S170.91,84,251.71,27c0,0,17.82-12.83,15.92-21.86,0,0,1.66-4.28-12-3.09,0,0-1.79.59-11.77-1.9s-65.94,35.52-65.94,35.52l-22.33-3V31l2.49-2.62s2.5-1.54-.12-5.46-4.16-4.52-4.16-4.52-1.06-3.44-8.19-.35L133,27.33,52.46,15.44l-12.12,7s73.25,25.85,92.32,39.21c0,0-16.93,13.19-29,19.07L75.09,62.2,66,66.47l7.49,21.21-26.38-3-6.77,4.81,31.72,14.8s-15.32,14.08,13.55,7.12L105.75,128l6.23-3.39Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.94,83.29,214,57.15l5.59,10,8.43-4.4s6.42-3.56,9.74,1.78,2.74,7.85-.83,11L228.06,81l17.59,29.46L237.92,118S190,86.26,183.86,85.07A157.4,157.4,0,0,0,167.94,83.29Z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.33,121.72s62.73,35.29,42.24,82.34c0,0,41.46-49.25-39.92-105.09C245.65,99,259.31,111.44,243.33,121.72Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.51,115.48S-12.06,154.16,11.11,205c0,0-42.41-45.95,38.5-106.07l13.9,7.42S60.12,111.38,63.51,115.48Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369,203.48A41.22,41.22,0,0,1,352.87,191l14.86-17.83q9.42,12.72,21.47,12.71,16.35,0,16.35-19.15v-55H364.93V90.29h67.2v75q0,21.3-10.57,31.95t-31,10.65A52.47,52.47,0,0,1,369,203.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.57,201.33a43.6,43.6,0,0,1-17.42-16.26,47.54,47.54,0,0,1,0-47.23,43.6,43.6,0,0,1,17.42-16.26,56.86,56.86,0,0,1,50.28,0,43.84,43.84,0,0,1,17.34,16.26,47.61,47.61,0,0,1,0,47.23,43.84,43.84,0,0,1-17.34,16.26,56.86,56.86,0,0,1-50.28,0Zm41.44-22q6.36-6.69,6.36-17.92T507,143.54a21.45,21.45,0,0,0-16.26-6.69,21.71,21.71,0,0,0-16.35,6.69Q468,150.23,468,161.45t6.44,17.92a21.71,21.71,0,0,0,16.35,6.69A21.45,21.45,0,0,0,507,179.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.87,117v88.83H613.43V195.3a34.11,34.11,0,0,1-12.21,8.84,38.6,38.6,0,0,1-15.36,3.05q-17.5,0-27.74-10.07t-10.24-29.89V117h25.76v46.4q0,21.47,18,21.46,9.24,0,14.86-6T612.11,161V117Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.63,119a46.28,46.28,0,0,1,18.08-3.3v23.77q-4.29-.33-5.78-.33-11.07,0-17.34,6.19t-6.27,18.58v41.94H653.56V117h24.6v11.72A28.64,28.64,0,0,1,690.63,119Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.47,125.62q10.15,9.91,10.16,29.39v50.86H780.87V159q0-10.57-4.63-15.77T762.87,138q-9.75,0-15.52,6T741.57,162v43.92H715.81V117h24.6v10.4a34.19,34.19,0,0,1,12.72-8.67,44.21,44.21,0,0,1,16.68-3Q786.31,115.72,796.47,125.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.17,168.72H842a20.87,20.87,0,0,0,8.59,13q6.76,4.8,16.84,4.79a34,34,0,0,0,12.3-2.06,29.84,29.84,0,0,0,10-6.52l13.71,14.86q-12.55,14.35-36.66,14.36-15,0-26.58-5.86a43,43,0,0,1-17.84-16.26A44.87,44.87,0,0,1,816,161.45a45.42,45.42,0,0,1,6.19-23.53,43.4,43.4,0,0,1,17-16.34,52.67,52.67,0,0,1,47.8-.25,41,41,0,0,1,16.6,16.1q6,10.48,6,24.35C909.66,162.11,909.5,164.43,909.17,168.72ZM848.9,140.15a21.09,21.09,0,0,0-7.27,13.54h43.76a21.27,21.27,0,0,0-7.27-13.45,21.69,21.69,0,0,0-14.53-5A22.18,22.18,0,0,0,848.9,140.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.1,117,965,211.32q-6.11,15.36-15.11,21.63t-21.71,6.28a45.12,45.12,0,0,1-13.71-2.15,30.26,30.26,0,0,1-11.06-5.94l9.41-18.33a22,22,0,0,0,6.85,4.12,21.2,21.2,0,0,0,7.68,1.49,13.63,13.63,0,0,0,8.59-2.56q3.3-2.56,5.94-8.5l.33-.83L903.72,117H930.3l24.94,60.27L980.33,117Z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.71,90.29V205.87H1127V158.48h-52.51v47.39H1047.7V90.29h26.75v45.57H1127V90.29Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.54,117v88.83h-24.43V195.3a34.23,34.23,0,0,1-12.22,8.84,38.6,38.6,0,0,1-15.36,3.05q-17.51,0-27.74-10.07t-10.24-29.89V117h25.76v46.4q0,21.47,18,21.46,9.24,0,14.86-6t5.62-17.91V117Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.28,121.41a40.9,40.9,0,0,1,15.93,16q5.79,10.32,5.78,24t-5.78,24a40.9,40.9,0,0,1-15.93,16,45.34,45.34,0,0,1-22.54,5.69q-18.33,0-27.91-11.56v10.24h-24.6V83.35H1302v43.1q9.73-10.74,26.75-10.73A45.24,45.24,0,0,1,1351.28,121.41Zm-10.73,58q6.35-6.69,6.35-17.92t-6.35-17.91a23.12,23.12,0,0,0-32.53,0q-6.36,6.69-6.36,17.91t6.36,17.92a23.12,23.12,0,0,0,32.53,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelLogo);
export default __webpack_public_path__ + "static/media/travel-logo.0d0f426bf20e53a4e7ce4d8b2acf9a6a.svg";
export { ForwardRef as ReactComponent };